import React from 'react';

const Issue = ({ title }) => {
  return (
    <div>
      <ul>
        <li>{title}</li>
      </ul>
    </div>
  );
};

export default Issue;
